import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes, BrowserRouter } from 'react-router-dom'
import '@fontsource-variable/geist'
import './scss/style.scss'
import './css/styles.css'
import 'react-image-crop/dist/ReactCrop.css'
import 'react-medium-image-zoom/dist/styles.css'
import PrivateRoute from './PrivateRoute'
import { useDispatch } from 'react-redux'
import { fetchCurrentUser } from './redux/actions/userActions'
import { AuthProvider } from './Auth'
import MemberEdit from './views/member/MemberEdit'
import AutoEnrollFinish from './views/member/AutoEnrollFinish'
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Password = React.lazy(() => import('./views/pages/login/Password'))
const Password2 = React.lazy(() => import('./views/pages/login/Password2'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const MapView = React.lazy(() => import('./views/election/MapView'))
const PublicCardOrder = React.lazy(() => import('./views/card/PublicCardOrder'))
const PublicCardOrderResult = React.lazy(() => import('./views/card/PublicCardOrderResult'))

function App() {
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(fetchCurrentUser())
  }, [])

  return (
    <AuthProvider>
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/password/init" name="Password Page" element={<Password />} />
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="/voting_map" element={<PrivateRoute />}>
              <Route exact path="/voting_map" name="Carte électorale" element={<MapView />} />
            </Route>
            <Route
              exact
              path="/members/enroll"
              name="Adhésion libre du membre"
              element={<MemberEdit />}
            />
            <Route
              exact
              path="/members/enroll/finish"
              name="Fin de l'adhésion libre du membre"
              element={<AutoEnrollFinish />}
            />
            <Route
              exact
              path="/member-card/order"
              name="Commande publique de carte membre"
              element={<PublicCardOrder />}
            />
            <Route
              exact
              path="/member-card/order/result"
              name="Résultat de la commande publique de carte membre"
              element={<PublicCardOrderResult />}
            />
            <Route path="*" element={<PrivateRoute />}>
              <Route exact path="*" element={<DefaultLayout />} />
            </Route>
            <Route path="/password/change" element={<PrivateRoute />}>
              <Route exact path="/password/change" element={<Password2 />} />
            </Route>
          </Routes>
        </Suspense>
      </HashRouter>
    </AuthProvider>
  )
}

export default App
